export default __webpack_public_path__ + "static/casecard7-969467522b902a1343177e3484adadab.jpg";